import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Spinner,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import axios from "axios";
import AdminSidebar from "../../../Components/AdminSidebar";
import Navbar from "../../../Components/Navbar";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { useSelector } from "react-redux";
import DealCard from "../../../Components/DealCard";
import CreateDeal from "./CreateDeal";

const DealList = () => {
  const [leads, setLeads] = useState([]);
  //console.log("deals",leads)
  const [loading, setLoading] = useState(true);
  const adminIdGlobal = useSelector((store) => store.authentication.users.id);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const fetchLeads = async () => {
    try {
      const res = await axios.get(
        `https://develop-project-360.onrender.com/getAllLeadDealsByRole?type=Deal&adminId=${adminIdGlobal}`
      );
      setLeads(res.data.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  if (loading) return <Spinner size="xl" />;

  return (
    <Flex>
      <AdminSidebar />
      <Box
        pl={{ base: "none", md: "10" }}
        pt={{ base: "none", md: "10" }}
        w={{ base: "100%", md: "80%" }}
      >
        <Navbar />

        {/* Main Content */}
        <Box flex="1" p={[4, 6]} overflowY="auto">
          <Heading size={"md"} textAlign={"start"}>
            Deals
          </Heading>
          <Flex
            direction={{ base: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ base: "flex-start", md: "center" }}
            flexWrap="wrap"
            gap={4}
          >
            <Breadcrumb
              spacing="8px"
              mt={6}
              mb={6}
              separator={<ChevronRightIcon color="gray.500" />}
            >
              <BreadcrumbItem>
                <BreadcrumbLink href="/admin">Dashboard</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <BreadcrumbLink href="#">Deals</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>

            <Flex
              justifyContent={{ base: "flex-start", md: "flex-end" }}
              w={{ base: "100%", md: "auto" }}
            >
              <Button
                onClick={onOpen} // Open the modal on click
                bgGradient="linear(to-r, green.300, teal.100)"
                _hover={{ bgGradient: "linear(to-r, green.100, green.400)" }}
                w={{ base: "100%", sm: "auto" }}
                px={6}
              >
                Create Deals
              </Button>
            </Flex>
          </Flex>

          {/* Modal */}
          <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Create New Deals</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <CreateDeal onClose={onClose} addNewLead={fetchLeads} />
              </ModalBody>
            </ModalContent>
          </Modal>

          <SimpleGrid columns={[1, 2, 3]} spacing={6}>
            {leads.map((lead) => (
              <DealCard key={lead._id} lead={lead} />
            ))}
          </SimpleGrid>
        </Box>
      </Box>
    </Flex>
  );
};

export default DealList;
